import { Dispatch } from 'redux'

import {
  actionTypes,
  fetchScansList,
  fetchScansListError,
  ScansFetchListAction,
  fetchScansListSuccess,
  fetchScansListByEmployee,
  ScansSetFilterParamsAction,
  fetchScansListByEmployeeError,
  ScansFetchListByEmployeeAction,
  fetchScansListByEmployeeSuccess
} from './actions'

import { applyFilterParams } from '../../utils/scans'

import { RootState } from '../rootReducer'
import { Scan } from '../../lib/interfaces/Scan.interface'
import { ScansByEmployee } from '../../lib/interfaces/ScansByEmployee.interface'

import * as scansApi from '../../lib/api/scans'

const { createLogic } = require('redux-logic')

type OnDoneType = () => void

const onFetchScansListLogic = createLogic({
  type: actionTypes.SCANS_FETCH_LIST,
  process({ action, getState }: { action: ScansFetchListAction, getState: () => RootState }, dispatch: Dispatch, done: OnDoneType) {
    const { next } = action.payload

    const filterParams = applyFilterParams(getState().scans.filterParams)
    scansApi.getScansList(filterParams)
      .then((scans: Scan[]) => {
        dispatch(fetchScansListSuccess(scans))
        if (next) { next(null, scans) }
      })
      .catch(err => {
        dispatch(fetchScansListError(err))
        if (next) { next(err) }
      })
      .then(done)
  }
})

const onFetchScansListByEmployeeLogic = createLogic({
  type: actionTypes.SCANS_FETCH_LIST_BY_EMPLOYEE,
  process({ action, getState }: { action: ScansFetchListByEmployeeAction, getState: () => RootState }, dispatch: Dispatch, done: OnDoneType) {
    const { next } = action.payload

    const filterParams = applyFilterParams(getState().scans.filterParams)
    scansApi.getScansListByEmployee(filterParams)
      .then((scans: ScansByEmployee[]) => {
        dispatch(fetchScansListByEmployeeSuccess(scans))

        if (next) { next(null, scans) }
      })
      .catch(err => {
        dispatch(fetchScansListByEmployeeError(err))
        if (next) { next(err) }
      })
      .then(done)
  }
})

// const onSetScansFilterParamsLogic = createLogic({
//   type: actionTypes.SCANS_SET_FILTER_PARAMS,
//   latest: true,
//   process({ action }: { action: ScansSetFilterParamsAction }, dispatch: Dispatch, done: OnDoneType) {
//     const { next, filterParams } = action.payload

//     if (filterParams.reportType === 'employee') {
//       dispatch(fetchScansListByEmployee(next))
//     }
//     else {
//       dispatch(fetchScansList(action.payload.next))
//     }
    
//     done()
//   }
// })

export const scansLogic = [
  onFetchScansListLogic,
  onFetchScansListByEmployeeLogic
  // onSetScansFilterParamsLogic
]



// WEBPACK FOOTER //
// ./src/store/scans/logic.ts